[
  {
    "name": "Afghanistan",
    "code": "AF",
    "emoji_flag": "🇦🇫"
  },
  {
    "name": "Albania",
    "code": "AL",
    "emoji_flag": "🇦🇱"
  },
  {
    "name": "Algeria",
    "code": "DZ",
    "emoji_flag": "🇩🇿"
  },
  {
    "name": "American Samoa",
    "code": "AS",
    "emoji_flag": "🇦🇸"
  },
  {
    "name": "Andorra",
    "code": "AD",
    "emoji_flag": "🇦🇩"
  },
  {
    "name": "Angola",
    "code": "AO",
    "emoji_flag": "🇦🇴"
  },
  {
    "name": "Anguilla",
    "code": "AI",
    "emoji_flag": "🇦🇮"
  },
  {
    "name": "Antarctica",
    "code": "AQ",
    "emoji_flag": "🇦🇶"
  },
  {
    "name": "Antigua and Barbuda",
    "code": "AG",
    "emoji_flag": "🇦🇬"
  },
  {
    "name": "Argentina",
    "code": "AR",
    "emoji_flag": "🇦🇷"
  },
  {
    "name": "Armenia",
    "code": "AM",
    "emoji_flag": "🇦🇲"
  },
  {
    "name": "Aruba",
    "code": "AW",
    "emoji_flag": "🇦🇼"
  },
  {
    "name": "Australia",
    "code": "AU",
    "emoji_flag": "🇦🇺"
  },
  {
    "name": "Austria",
    "code": "AT",
    "emoji_flag": "🇦🇹"
  },
  {
    "name": "Azerbaijan",
    "code": "AZ",
    "emoji_flag": "🇦🇿"
  },
  {
    "name": "Bahamas",
    "code": "BS",
    "emoji_flag": "🇧🇸"
  },
  {
    "name": "Bahrain",
    "code": "BH",
    "emoji_flag": "🇧🇭"
  },
  {
    "name": "Bangladesh",
    "code": "BD",
    "emoji_flag": "🇧🇩"
  },
  {
    "name": "Barbados",
    "code": "BB",
    "emoji_flag": "🇧🇧"
  },
  {
    "name": "Belarus",
    "code": "BY",
    "emoji_flag": "🇧🇾"
  },
  {
    "name": "Belgium",
    "code": "BE",
    "emoji_flag": "🇧🇪"
  },
  {
    "name": "Belize",
    "code": "BZ",
    "emoji_flag": "🇧🇿"
  },
  {
    "name": "Benin",
    "code": "BJ",
    "emoji_flag": "🇧🇯"
  },
  {
    "name": "Bermuda",
    "code": "BM",
    "emoji_flag": "🇧🇲"
  },
  {
    "name": "Bhutan",
    "code": "BT",
    "emoji_flag": "🇧🇹"
  },
  {
    "name": "Bolivia",
    "code": "BO",
    "emoji_flag": "🇧🇴"
  },
  {
    "name": "Bonaire, Sint Eustatius and Saba",
    "code": "BQ",
    "emoji_flag": "🇧🇶"
  },
  {
    "name": "Bosnia and Herzegovina",
    "code": "BA",
    "emoji_flag": "🇧🇦"
  },
  {
    "name": "Botswana",
    "code": "BW",
    "emoji_flag": "🇧🇼"
  },
  {
    "name": "Bouvet Island",
    "code": "BV",
    "emoji_flag": "🇧🇻"
  },
  {
    "name": "Brazil",
    "code": "BR",
    "emoji_flag": "🇧🇷"
  },
  {
    "name": "British Indian Ocean Territory",
    "code": "IO",
    "emoji_flag": "🇮🇴"
  },
  {
    "name": "Brunei Darussalam",
    "code": "BN",
    "emoji_flag": "🇧🇳"
  },
  {
    "name": "Bulgaria",
    "code": "BG",
    "emoji_flag": "🇧🇬"
  },
  {
    "name": "Burkina Faso",
    "code": "BF",
    "emoji_flag": "🇧🇫"
  },
  {
    "name": "Burundi",
    "code": "BI",
    "emoji_flag": "🇧🇮"
  },
  {
    "name": "Cabo Verde",
    "code": "CV",
    "emoji_flag": "🇨🇻"
  },
  {
    "name": "Cambodia",
    "code": "KH",
    "emoji_flag": "🇰🇭"
  },
  {
    "name": "Cameroon",
    "code": "CM",
    "emoji_flag": "🇨🇲"
  },
  {
    "name": "Canada",
    "code": "CA",
    "emoji_flag": "🇨🇦"
  },
  {
    "name": "Cayman Islands",
    "code": "KY",
    "emoji_flag": "🇰🇾"
  },
  {
    "name": "Central African Republic",
    "code": "CF",
    "emoji_flag": "🇨🇫"
  },
  {
    "name": "Chad",
    "code": "TD",
    "emoji_flag": "🇹🇩"
  },
  {
    "name": "Chile",
    "code": "CL",
    "emoji_flag": "🇨🇱"
  },
  {
    "name": "China",
    "code": "CN",
    "emoji_flag": "🇨🇳"
  },
  {
    "name": "Christmas Island",
    "code": "CX",
    "emoji_flag": "🇨🇽"
  },
  {
    "name": "Cocos (Keeling) Islands",
    "code": "CC",
    "emoji_flag": "🇨🇨"
  },
  {
    "name": "Colombia",
    "code": "CO",
    "emoji_flag": "🇨🇴"
  },
  {
    "name": "Comoros",
    "code": "KM",
    "emoji_flag": "🇰🇲"
  },
  {
    "name": "Congo",
    "code": "CG",
    "emoji_flag": "🇨🇬"
  },
  {
    "name": "Congo, The Democratic Republic of the",
    "code": "CD",
    "emoji_flag": "🇨🇩"
  },
  {
    "name": "Cook Islands",
    "code": "CK",
    "emoji_flag": "🇨🇰"
  },
  {
    "name": "Costa Rica",
    "code": "CR",
    "emoji_flag": "🇨🇷"
  },
  {
    "name": "Croatia",
    "code": "HR",
    "emoji_flag": "🇭🇷"
  },
  {
    "name": "Cuba",
    "code": "CU",
    "emoji_flag": "🇨🇺"
  },
  {
    "name": "Curaçao",
    "code": "CW",
    "emoji_flag": "🇨🇼"
  },
  {
    "name": "Cyprus",
    "code": "CY",
    "emoji_flag": "🇨🇾"
  },
  {
    "name": "Czechia",
    "code": "CZ",
    "emoji_flag": "🇨🇿"
  },
  {
    "name": "Côte d'Ivoire",
    "code": "CI",
    "emoji_flag": "🇨🇮"
  },
  {
    "name": "Denmark",
    "code": "DK",
    "emoji_flag": "🇩🇰"
  },
  {
    "name": "Djibouti",
    "code": "DJ",
    "emoji_flag": "🇩🇯"
  },
  {
    "name": "Dominica",
    "code": "DM",
    "emoji_flag": "🇩🇲"
  },
  {
    "name": "Dominican Republic",
    "code": "DO",
    "emoji_flag": "🇩🇴"
  },
  {
    "name": "Ecuador",
    "code": "EC",
    "emoji_flag": "🇪🇨"
  },
  {
    "name": "Egypt",
    "code": "EG",
    "emoji_flag": "🇪🇬"
  },
  {
    "name": "El Salvador",
    "code": "SV",
    "emoji_flag": "🇸🇻"
  },
  {
    "name": "Equatorial Guinea",
    "code": "GQ",
    "emoji_flag": "🇬🇶"
  },
  {
    "name": "Eritrea",
    "code": "ER",
    "emoji_flag": "🇪🇷"
  },
  {
    "name": "Estonia",
    "code": "EE",
    "emoji_flag": "🇪🇪"
  },
  {
    "name": "Eswatini",
    "code": "SZ",
    "emoji_flag": "🇸🇿"
  },
  {
    "name": "Ethiopia",
    "code": "ET",
    "emoji_flag": "🇪🇹"
  },
  {
    "name": "Falkland Islands (Malvinas)",
    "code": "FK",
    "emoji_flag": "🇫🇰"
  },
  {
    "name": "Faroe Islands",
    "code": "FO",
    "emoji_flag": "🇫🇴"
  },
  {
    "name": "Fiji",
    "code": "FJ",
    "emoji_flag": "🇫🇯"
  },
  {
    "name": "Finland",
    "code": "FI",
    "emoji_flag": "🇫🇮"
  },
  {
    "name": "France",
    "code": "FR",
    "emoji_flag": "🇫🇷"
  },
  {
    "name": "French Guiana",
    "code": "GF",
    "emoji_flag": "🇬🇫"
  },
  {
    "name": "French Polynesia",
    "code": "PF",
    "emoji_flag": "🇵🇫"
  },
  {
    "name": "French Southern Territories",
    "code": "TF",
    "emoji_flag": "🇹🇫"
  },
  {
    "name": "Gabon",
    "code": "GA",
    "emoji_flag": "🇬🇦"
  },
  {
    "name": "Gambia",
    "code": "GM",
    "emoji_flag": "🇬🇲"
  },
  {
    "name": "Georgia",
    "code": "GE",
    "emoji_flag": "🇬🇪"
  },
  {
    "name": "Germany",
    "code": "DE",
    "emoji_flag": "🇩🇪"
  },
  {
    "name": "Ghana",
    "code": "GH",
    "emoji_flag": "🇬🇭"
  },
  {
    "name": "Gibraltar",
    "code": "GI",
    "emoji_flag": "🇬🇮"
  },
  {
    "name": "Greece",
    "code": "GR",
    "emoji_flag": "🇬🇷"
  },
  {
    "name": "Greenland",
    "code": "GL",
    "emoji_flag": "🇬🇱"
  },
  {
    "name": "Grenada",
    "code": "GD",
    "emoji_flag": "🇬🇩"
  },
  {
    "name": "Guadeloupe",
    "code": "GP",
    "emoji_flag": "🇬🇵"
  },
  {
    "name": "Guam",
    "code": "GU",
    "emoji_flag": "🇬🇺"
  },
  {
    "name": "Guatemala",
    "code": "GT",
    "emoji_flag": "🇬🇹"
  },
  {
    "name": "Guernsey",
    "code": "GG",
    "emoji_flag": "🇬🇬"
  },
  {
    "name": "Guinea",
    "code": "GN",
    "emoji_flag": "🇬🇳"
  },
  {
    "name": "Guinea-Bissau",
    "code": "GW",
    "emoji_flag": "🇬🇼"
  },
  {
    "name": "Guyana",
    "code": "GY",
    "emoji_flag": "🇬🇾"
  },
  {
    "name": "Haiti",
    "code": "HT",
    "emoji_flag": "🇭🇹"
  },
  {
    "name": "Heard Island and McDonald Islands",
    "code": "HM",
    "emoji_flag": "🇭🇲"
  },
  {
    "name": "Holy See (Vatican City State)",
    "code": "VA",
    "emoji_flag": "🇻🇦"
  },
  {
    "name": "Honduras",
    "code": "HN",
    "emoji_flag": "🇭🇳"
  },
  {
    "name": "Hong Kong",
    "code": "HK",
    "emoji_flag": "🇭🇰"
  },
  {
    "name": "Hungary",
    "code": "HU",
    "emoji_flag": "🇭🇺"
  },
  {
    "name": "Iceland",
    "code": "IS",
    "emoji_flag": "🇮🇸"
  },
  {
    "name": "India",
    "code": "IN",
    "emoji_flag": "🇮🇳"
  },
  {
    "name": "Indonesia",
    "code": "ID",
    "emoji_flag": "🇮🇩"
  },
  {
    "name": "Iran",
    "code": "IR",
    "emoji_flag": "🇮🇷"
  },
  {
    "name": "Iraq",
    "code": "IQ",
    "emoji_flag": "🇮🇶"
  },
  {
    "name": "Ireland",
    "code": "IE",
    "emoji_flag": "🇮🇪"
  },
  {
    "name": "Isle of Man",
    "code": "IM",
    "emoji_flag": "🇮🇲"
  },
  {
    "name": "Israel",
    "code": "IL",
    "emoji_flag": "🇮🇱"
  },
  {
    "name": "Italy",
    "code": "IT",
    "emoji_flag": "🇮🇹"
  },
  {
    "name": "Jamaica",
    "code": "JM",
    "emoji_flag": "🇯🇲"
  },
  {
    "name": "Japan",
    "code": "JP",
    "emoji_flag": "🇯🇵"
  },
  {
    "name": "Jersey",
    "code": "JE",
    "emoji_flag": "🇯🇪"
  },
  {
    "name": "Jordan",
    "code": "JO",
    "emoji_flag": "🇯🇴"
  },
  {
    "name": "Kazakhstan",
    "code": "KZ",
    "emoji_flag": "🇰🇿"
  },
  {
    "name": "Kenya",
    "code": "KE",
    "emoji_flag": "🇰🇪"
  },
  {
    "name": "Kiribati",
    "code": "KI",
    "emoji_flag": "🇰🇮"
  },
  {
    "name": "Kuwait",
    "code": "KW",
    "emoji_flag": "🇰🇼"
  },
  {
    "name": "Kyrgyzstan",
    "code": "KG",
    "emoji_flag": "🇰🇬"
  },
  {
    "name": "Lao People's Democratic Republic",
    "code": "LA",
    "emoji_flag": "🇱🇦"
  },
  {
    "name": "Latvia",
    "code": "LV",
    "emoji_flag": "🇱🇻"
  },
  {
    "name": "Lebanon",
    "code": "LB",
    "emoji_flag": "🇱🇧"
  },
  {
    "name": "Lesotho",
    "code": "LS",
    "emoji_flag": "🇱🇸"
  },
  {
    "name": "Liberia",
    "code": "LR",
    "emoji_flag": "🇱🇷"
  },
  {
    "name": "Libya",
    "code": "LY",
    "emoji_flag": "🇱🇾"
  },
  {
    "name": "Liechtenstein",
    "code": "LI",
    "emoji_flag": "🇱🇮"
  },
  {
    "name": "Lithuania",
    "code": "LT",
    "emoji_flag": "🇱🇹"
  },
  {
    "name": "Luxembourg",
    "code": "LU",
    "emoji_flag": "🇱🇺"
  },
  {
    "name": "Macao",
    "code": "MO",
    "emoji_flag": "🇲🇴"
  },
  {
    "name": "Madagascar",
    "code": "MG",
    "emoji_flag": "🇲🇬"
  },
  {
    "name": "Malawi",
    "code": "MW",
    "emoji_flag": "🇲🇼"
  },
  {
    "name": "Malaysia",
    "code": "MY",
    "emoji_flag": "🇲🇾"
  },
  {
    "name": "Maldives",
    "code": "MV",
    "emoji_flag": "🇲🇻"
  },
  {
    "name": "Mali",
    "code": "ML",
    "emoji_flag": "🇲🇱"
  },
  {
    "name": "Malta",
    "code": "MT",
    "emoji_flag": "🇲🇹"
  },
  {
    "name": "Marshall Islands",
    "code": "MH",
    "emoji_flag": "🇲🇭"
  },
  {
    "name": "Martinique",
    "code": "MQ",
    "emoji_flag": "🇲🇶"
  },
  {
    "name": "Mauritania",
    "code": "MR",
    "emoji_flag": "🇲🇷"
  },
  {
    "name": "Mauritius",
    "code": "MU",
    "emoji_flag": "🇲🇺"
  },
  {
    "name": "Mayotte",
    "code": "YT",
    "emoji_flag": "🇾🇹"
  },
  {
    "name": "Mexico",
    "code": "MX",
    "emoji_flag": "🇲🇽"
  },
  {
    "name": "Micronesia, Federated States of",
    "code": "FM",
    "emoji_flag": "🇫🇲"
  },
  {
    "name": "Moldova",
    "code": "MD",
    "emoji_flag": "🇲🇩"
  },
  {
    "name": "Monaco",
    "code": "MC",
    "emoji_flag": "🇲🇨"
  },
  {
    "name": "Mongolia",
    "code": "MN",
    "emoji_flag": "🇲🇳"
  },
  {
    "name": "Montenegro",
    "code": "ME",
    "emoji_flag": "🇲🇪"
  },
  {
    "name": "Montserrat",
    "code": "MS",
    "emoji_flag": "🇲🇸"
  },
  {
    "name": "Morocco",
    "code": "MA",
    "emoji_flag": "🇲🇦"
  },
  {
    "name": "Mozambique",
    "code": "MZ",
    "emoji_flag": "🇲🇿"
  },
  {
    "name": "Myanmar",
    "code": "MM",
    "emoji_flag": "🇲🇲"
  },
  {
    "name": "Namibia",
    "code": "NA",
    "emoji_flag": "🇳🇦"
  },
  {
    "name": "Nauru",
    "code": "NR",
    "emoji_flag": "🇳🇷"
  },
  {
    "name": "Nepal",
    "code": "NP",
    "emoji_flag": "🇳🇵"
  },
  {
    "name": "Netherlands",
    "code": "NL",
    "emoji_flag": "🇳🇱"
  },
  {
    "name": "New Caledonia",
    "code": "NC",
    "emoji_flag": "🇳🇨"
  },
  {
    "name": "New Zealand",
    "code": "NZ",
    "emoji_flag": "🇳🇿"
  },
  {
    "name": "Nicaragua",
    "code": "NI",
    "emoji_flag": "🇳🇮"
  },
  {
    "name": "Niger",
    "code": "NE",
    "emoji_flag": "🇳🇪"
  },
  {
    "name": "Nigeria",
    "code": "NG",
    "emoji_flag": "🇳🇬"
  },
  {
    "name": "Niue",
    "code": "NU",
    "emoji_flag": "🇳🇺"
  },
  {
    "name": "Norfolk Island",
    "code": "NF",
    "emoji_flag": "🇳🇫"
  },
  {
    "name": "North Korea",
    "code": "KP",
    "emoji_flag": "🇰🇵"
  },
  {
    "name": "North Macedonia",
    "code": "MK",
    "emoji_flag": "🇲🇰"
  },
  {
    "name": "Northern Mariana Islands",
    "code": "MP",
    "emoji_flag": "🇲🇵"
  },
  {
    "name": "Norway",
    "code": "NO",
    "emoji_flag": "🇳🇴"
  },
  {
    "name": "Oman",
    "code": "OM",
    "emoji_flag": "🇴🇲"
  },
  {
    "name": "Pakistan",
    "code": "PK",
    "emoji_flag": "🇵🇰"
  },
  {
    "name": "Palau",
    "code": "PW",
    "emoji_flag": "🇵🇼"
  },
  {
    "name": "Palestine, State of",
    "code": "PS",
    "emoji_flag": "🇵🇸"
  },
  {
    "name": "Panama",
    "code": "PA",
    "emoji_flag": "🇵🇦"
  },
  {
    "name": "Papua New Guinea",
    "code": "PG",
    "emoji_flag": "🇵🇬"
  },
  {
    "name": "Paraguay",
    "code": "PY",
    "emoji_flag": "🇵🇾"
  },
  {
    "name": "Peru",
    "code": "PE",
    "emoji_flag": "🇵🇪"
  },
  {
    "name": "Philippines",
    "code": "PH",
    "emoji_flag": "🇵🇭"
  },
  {
    "name": "Pitcairn",
    "code": "PN",
    "emoji_flag": "🇵🇳"
  },
  {
    "name": "Poland",
    "code": "PL",
    "emoji_flag": "🇵🇱"
  },
  {
    "name": "Portugal",
    "code": "PT",
    "emoji_flag": "🇵🇹"
  },
  {
    "name": "Puerto Rico",
    "code": "PR",
    "emoji_flag": "🇵🇷"
  },
  {
    "name": "Qatar",
    "code": "QA",
    "emoji_flag": "🇶🇦"
  },
  {
    "name": "Romania",
    "code": "RO",
    "emoji_flag": "🇷🇴"
  },
  {
    "name": "Russian Federation",
    "code": "RU",
    "emoji_flag": "🇷🇺"
  },
  {
    "name": "Rwanda",
    "code": "RW",
    "emoji_flag": "🇷🇼"
  },
  {
    "name": "Réunion",
    "code": "RE",
    "emoji_flag": "🇷🇪"
  },
  {
    "name": "Saint Barthélemy",
    "code": "BL",
    "emoji_flag": "🇧🇱"
  },
  {
    "name": "Saint Helena, Ascension and Tristan da Cunha",
    "code": "SH",
    "emoji_flag": "🇸🇭"
  },
  {
    "name": "Saint Kitts and Nevis",
    "code": "KN",
    "emoji_flag": "🇰🇳"
  },
  {
    "name": "Saint Lucia",
    "code": "LC",
    "emoji_flag": "🇱🇨"
  },
  {
    "name": "Saint Martin (French part)",
    "code": "MF",
    "emoji_flag": "🇲🇫"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "code": "PM",
    "emoji_flag": "🇵🇲"
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "code": "VC",
    "emoji_flag": "🇻🇨"
  },
  {
    "name": "Samoa",
    "code": "WS",
    "emoji_flag": "🇼🇸"
  },
  {
    "name": "San Marino",
    "code": "SM",
    "emoji_flag": "🇸🇲"
  },
  {
    "name": "Sao Tome and Principe",
    "code": "ST",
    "emoji_flag": "🇸🇹"
  },
  {
    "name": "Saudi Arabia",
    "code": "SA",
    "emoji_flag": "🇸🇦"
  },
  {
    "name": "Senegal",
    "code": "SN",
    "emoji_flag": "🇸🇳"
  },
  {
    "name": "Serbia",
    "code": "RS",
    "emoji_flag": "🇷🇸"
  },
  {
    "name": "Seychelles",
    "code": "SC",
    "emoji_flag": "🇸🇨"
  },
  {
    "name": "Sierra Leone",
    "code": "SL",
    "emoji_flag": "🇸🇱"
  },
  {
    "name": "Singapore",
    "code": "SG",
    "emoji_flag": "🇸🇬"
  },
  {
    "name": "Sint Maarten (Dutch part)",
    "code": "SX",
    "emoji_flag": "🇸🇽"
  },
  {
    "name": "Slovakia",
    "code": "SK",
    "emoji_flag": "🇸🇰"
  },
  {
    "name": "Slovenia",
    "code": "SI",
    "emoji_flag": "🇸🇮"
  },
  {
    "name": "Solomon Islands",
    "code": "SB",
    "emoji_flag": "🇸🇧"
  },
  {
    "name": "Somalia",
    "code": "SO",
    "emoji_flag": "🇸🇴"
  },
  {
    "name": "South Africa",
    "code": "ZA",
    "emoji_flag": "🇿🇦"
  },
  {
    "name": "South Georgia and the South Sandwich Islands",
    "code": "GS",
    "emoji_flag": "🇬🇸"
  },
  {
    "name": "South Korea",
    "code": "KR",
    "emoji_flag": "🇰🇷"
  },
  {
    "name": "South Sudan",
    "code": "SS",
    "emoji_flag": "🇸🇸"
  },
  {
    "name": "Spain",
    "code": "ES",
    "emoji_flag": "🇪🇸"
  },
  {
    "name": "Sri Lanka",
    "code": "LK",
    "emoji_flag": "🇱🇰"
  },
  {
    "name": "Sudan",
    "code": "SD",
    "emoji_flag": "🇸🇩"
  },
  {
    "name": "Suriname",
    "code": "SR",
    "emoji_flag": "🇸🇷"
  },
  {
    "name": "Svalbard and Jan Mayen",
    "code": "SJ",
    "emoji_flag": "🇸🇯"
  },
  {
    "name": "Sweden",
    "code": "SE",
    "emoji_flag": "🇸🇪"
  },
  {
    "name": "Switzerland",
    "code": "CH",
    "emoji_flag": "🇨🇭"
  },
  {
    "name": "Syrian Arab Republic",
    "code": "SY",
    "emoji_flag": "🇸🇾"
  },
  {
    "name": "Taiwan",
    "code": "TW",
    "emoji_flag": "🇹🇼"
  },
  {
    "name": "Tajikistan",
    "code": "TJ",
    "emoji_flag": "🇹🇯"
  },
  {
    "name": "Tanzania",
    "code": "TZ",
    "emoji_flag": "🇹🇿"
  },
  {
    "name": "Thailand",
    "code": "TH",
    "emoji_flag": "🇹🇭"
  },
  {
    "name": "Timor-Leste",
    "code": "TL",
    "emoji_flag": "🇹🇱"
  },
  {
    "name": "Togo",
    "code": "TG",
    "emoji_flag": "🇹🇬"
  },
  {
    "name": "Tokelau",
    "code": "TK",
    "emoji_flag": "🇹🇰"
  },
  {
    "name": "Tonga",
    "code": "TO",
    "emoji_flag": "🇹🇴"
  },
  {
    "name": "Trinidad and Tobago",
    "code": "TT",
    "emoji_flag": "🇹🇹"
  },
  {
    "name": "Tunisia",
    "code": "TN",
    "emoji_flag": "🇹🇳"
  },
  {
    "name": "Turkmenistan",
    "code": "TM",
    "emoji_flag": "🇹🇲"
  },
  {
    "name": "Turks and Caicos Islands",
    "code": "TC",
    "emoji_flag": "🇹🇨"
  },
  {
    "name": "Tuvalu",
    "code": "TV",
    "emoji_flag": "🇹🇻"
  },
  {
    "name": "Türkiye",
    "code": "TR",
    "emoji_flag": "🇹🇷"
  },
  {
    "name": "Uganda",
    "code": "UG",
    "emoji_flag": "🇺🇬"
  },
  {
    "name": "Ukraine",
    "code": "UA",
    "emoji_flag": "🇺🇦"
  },
  {
    "name": "United Arab Emirates",
    "code": "AE",
    "emoji_flag": "🇦🇪"
  },
  {
    "name": "United Kingdom",
    "code": "GB",
    "emoji_flag": "🇬🇧"
  },
  {
    "name": "United States",
    "code": "US",
    "emoji_flag": "🇺🇸"
  },
  {
    "name": "United States Minor Outlying Islands",
    "code": "UM",
    "emoji_flag": "🇺🇲"
  },
  {
    "name": "Uruguay",
    "code": "UY",
    "emoji_flag": "🇺🇾"
  },
  {
    "name": "Uzbekistan",
    "code": "UZ",
    "emoji_flag": "🇺🇿"
  },
  {
    "name": "Vanuatu",
    "code": "VU",
    "emoji_flag": "🇻🇺"
  },
  {
    "name": "Venezuela",
    "code": "VE",
    "emoji_flag": "🇻🇪"
  },
  {
    "name": "Vietnam",
    "code": "VN",
    "emoji_flag": "🇻🇳"
  },
  {
    "name": "Virgin Islands, British",
    "code": "VG",
    "emoji_flag": "🇻🇬"
  },
  {
    "name": "Virgin Islands, U.S.",
    "code": "VI",
    "emoji_flag": "🇻🇮"
  },
  {
    "name": "Wallis and Futuna",
    "code": "WF",
    "emoji_flag": "🇼🇫"
  },
  {
    "name": "Western Sahara",
    "code": "EH",
    "emoji_flag": "🇪🇭"
  },
  {
    "name": "Yemen",
    "code": "YE",
    "emoji_flag": "🇾🇪"
  },
  {
    "name": "Zambia",
    "code": "ZM",
    "emoji_flag": "🇿🇲"
  },
  {
    "name": "Zimbabwe",
    "code": "ZW",
    "emoji_flag": "🇿🇼"
  },
  {
    "name": "Åland Islands",
    "code": "AX",
    "emoji_flag": "🇦🇽"
  }
]